import classNames from "classnames";
import { useEffect, useState } from "react";

import { Icon } from "src/app/components/icon/Icon";

import searchCSS from "./Search.module.css";

const Search = ({ handleSearchTerm }: { handleSearchTerm: (searchTerm: string) => void }) => {
  const [searchInputValue, setSearchInputValue] = useState("");

  useEffect(() => {
    handleSearchTerm(searchInputValue);
  }, [handleSearchTerm, searchInputValue]);

  const handleSearchInputChange = (event: React.FormEvent<HTMLInputElement>) => {
    setSearchInputValue(event.currentTarget.value);
  };

  const resetSearchInputField = () => {
    setSearchInputValue("");
  };

  return (
    <div className="u-pos-relative">
      <div className={classNames("u-flex", "u-flex-content-between", "u-flex-items-center", searchCSS.searchGroupNew)}>
        <button
          type="button"
          className={classNames("u-z-index1", "u-t-black", "u-t-f15p", "u-p0", "u-pos-absolute", "u-cursor-pointer", searchCSS.searchButtonNew)}
        >
          <Icon name="search" className="u-t-valign-mid" />
        </button>
        <input value={searchInputValue} onChange={handleSearchInputChange} type="text" placeholder="Pretraži" />
        <button
          type="button"
          onClick={resetSearchInputField}
          className={classNames("u-z-index1", "u-t-secondary", "u-t-f10p", "u-p0", "u-none", "u-cursor-pointer", searchCSS.clearButtonNew)}
        >
          <Icon name="times" className="u-t-valign-mid" />
        </button>
      </div>
    </div>
  );
};

export default Search;
